/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { configureStore } from '@reduxjs/toolkit';
import roomSlice, { RoomState}  from './slices/room';
import deviceSlice, { DeviceState } from './slices/device';

export interface RootState {
  room: RoomState;
  device: DeviceState;
}

const store = configureStore({
  reducer: {
    room: roomSlice,
    device: deviceSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// 直接在store初始化后触发历史消息加载（移除unwrap()）
// console.log('store初始化后触发 fetchAndInitHistoryMsg');
// store.dispatch(fetchAndInitHistoryMsg())
// .then((formattedMessages) => {  // 直接处理返回的结果
//   console.log('fetchAndInitHistoryMsg 执行成功:', formattedMessages);
// })
// .catch((error) => {
//   console.error('fetchAndInitHistoryMsg 执行失败:', error);
// });

export default store;
